import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { approveAndForwardReferralAction } from "../../Redux/Actions/index"; // Correctly importing the specific action
import { Button, Spinner } from "react-bootstrap";

const ApproveConfirmation = (props: any) => {
  const { referral, onHide, apiCallCompleted, onApprovalSuccess } = props;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = () => {
    setIsLoading(true);
    dispatch(
      approveAndForwardReferralAction(referral._id, (res: any) => {
        setIsLoading(false)
        apiCallCompleted(res);
        if (res && res.data) {
          onApprovalSuccess(referral._id);
        } else {
          onHide();
        }
      })
    );
  };
  return (
    <div className="p-3">
      <p>
        Are you sure you want to approve and send this profile to Questlight for
        the hiring process?
      </p>
      <div className="d-flex justify-content-center mt-4">
        <button type="button" onClick={onHide} className="btn btn-outline me-2" disabled={isLoading}>
          Cancel
        </button>
        <Button variant="primary" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="ms-2">Confirming...</span>
            </>
          ) : (
            "Confirm"
          )}
        </Button>
      </div>
    </div>
  );
};

export default ApproveConfirmation;